/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export const LEGAL_DOCUMENTS = {
  privacy: {
    titleAr: "سياسة الخصوصية",
    titleEn: "Privacy Policy",
    files: {
      ar: ["privacy-policy.ar.txt", "سياسة الخصوصية.txt"],
      en: ["privacy-policy.en.txt"],
    },
  },
  terms: {
    titleAr: "الشروط والأحكام",
    titleEn: "Terms and Conditions",
    files: {
      ar: ["terms-and-conditions.ar.txt", "الشروط والأحكام.txt"],
      en: ["terms-and-conditions.en.txt"],
    },
  },
};

export async function loadLegalDocument(documentKey, language = "ar") {
  const doc = LEGAL_DOCUMENTS[documentKey];
  if (!doc) throw new Error("Unknown legal document key");

  const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  const langKey = language === "ar" ? "ar" : "en";
  const fileNames = doc.files?.[langKey] || doc.files?.ar || [];

  const candidates = Array.from(
    new Set(
      fileNames.flatMap((file) => {
        const encoded = encodeURIComponent(file);
        return [`${base}/${file}`, `${base}/${encoded}`, `/${file}`, `/${encoded}`];
      })
    )
  );

  for (const url of candidates) {
    try {
      const response = await fetch(url);
      if (response.ok) return response.text();
    } catch (error) {
      // Try next candidate URL.
    }
  }

  throw new Error("Failed to load legal document");
}
